<template>
  <div class="404NotFound">
    <h1>404 Not Found</h1>
  </div>
</template>

<script>

export default {
  name: '404NotFound',
  data() {
    return {}
  }
}
</script>
